(function () {
    'use strict';
    app.service('AuthenticationService', ['$q', '$cookies',
        function ($q, $cookies) {
            var tokenInfo;

            this.setTokenInfo = function (data) {
                tokenInfo = data;
                var expireDate = new Date();
                expireDate.setHours(expireDate.getHours() + 3);
                document.cookie = "TokenInfo=" + encodeURI(JSON.stringify(tokenInfo.accessToken)) + ";" + "expires=" + expireDate.toGMTString() + ";SameSite=None;Secure";
                //commented below code and implemented above because after implementing Osano cookie samesite attribute was set as Lax and that was causing issue in payment flow. so used plain javascript to set none
                //$cookies.put("TokenInfo", JSON.stringify(tokenInfo.accessToken), { expires: expireDate });
                $cookies.put("_rtInf", tokenInfo.refresh_token, { expires: expireDate });
            }

            this.getTokenInfo = function () {
                if ($cookies.get("TokenInfo") != undefined) {
                    tokenInfo = JSON.parse($cookies.get("TokenInfo"));
                }
                else {
                    tokenInfo = undefined;
                }
                return tokenInfo;
            }

            this.removeToken = function () {
                
                tokenInfo = null;
                var cookies = $cookies.getAll();
                angular.forEach(cookies, function (v, k) {
                    $cookies.remove(k);
                });

                localStorage.clear();
                cookies = null;
            }

            this.init = function () {
                if ($cookies.get("TokenInfo") != undefined) {
                    tokenInfo = JSON.parse($cookies.get("TokenInfo"));
                }
            }

            this.setHeader = function (http) {
                delete http.defaults.headers.common['X-Requested-With'];
                if ((tokenInfo != undefined) && (tokenInfo != null) && (tokenInfo != "")) {
                    http.defaults.headers.common['Authorization'] = 'Bearer ' + tokenInfo;
                    http.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8';
                }
            }

            this.init();
        }
    ]);
})();